var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46 0H12.384V18.165C10.371 18.547 8.893 18.7 7.288 18.7C2.497 18.7 0 16.534 0 12.38C0 8.379 2.65 5.78 6.753 5.78C7.39 5.78 7.874 5.831 8.46 5.984V0ZM8.46 9.143C8.03345 8.99891 7.58514 8.92989 7.135 8.939C5.147 8.939 4.001 10.162 4.001 12.303C4.001 14.393 5.097 15.539 7.11 15.539C7.543 15.539 7.9 15.514 8.46 15.437V9.143ZM18.628 6.06V15.157C18.628 18.291 18.399 19.795 17.711 21.094C17.074 22.343 16.233 23.133 14.5 23.999L10.856 22.266C12.589 21.451 13.43 20.737 13.965 19.641C14.526 18.52 14.704 17.22 14.704 13.806V6.059L18.628 6.06ZM14.704 0.021H18.628V4.047H14.704V0.021Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.1d7c66f119bd5dad57a846ab9c60e3da.svg";
export { ForwardRef as ReactComponent };